import React, { Fragment, useEffect, useState } from 'react';
import MyEditor from "./tools/MyEditor";
import { OpenTextGet, OpenTextSet, deleteOpenText, addOpenText } from '../server/OpenText';
import { setPreload } from '../server/CartsOpen';
import DOMPurify from 'dompurify';
import { useSelector, useDispatch } from 'react-redux';
import { globalFileIcon } from '../../axiosInstance';


const OpenText = ({ShowHome}) => {
    const dispatch = useDispatch();
    const [homeObj, setHomeObj] = useState([]);
    const [editId, setEditId] = useState(null);
    const role = useSelector(state => state.user.role);

    const deleteText = (id) => {
        deleteOpenText(id).then(() => {
            setHomeObj([...homeObj.filter(msg => msg.Id !== id)]);
        }).catch(() => console.log("error"));
    }

    useEffect(() => {
        OpenTextGet()
            .then(x => setHomeObj(x.data))
            .catch(() => console.log("error"))
    }, [role])

    const createMarkup = (html) => {
        return {
            __html: DOMPurify.sanitize(html)
        }
    }

    const convertContentToHTML = (value, type, Id) => {
        const obj = [...homeObj];
        const index = obj.findIndex(x => x.Id === Id);
        obj[index][type] = value;
        setHomeObj(obj);
    }

    const addMassage = () => { 
        const today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setUTCDate(today.getUTCDate() + 1); 
        const val = {Active: 1, 
            FromDate: today.toISOString(),
            OrderNumber: null,
            Text: " ",
            ToDate: tomorrow.toISOString(),};
        addOpenText(val)
            .then(x => {
                setHomeObj([...homeObj, {...val, Id: x.data.id}]);
                setEditId(x.data.id);
            })
            .catch(() => console.log("error"));
    }

    const save = (Id) => {
        dispatch(setPreload(true));
        const obj = [...homeObj];
        const index = obj.findIndex(x => x.Id === Id);

        OpenTextSet(obj[index])
            .then(x => {
                obj[index] = x.data;
                setHomeObj(obj);
                setEditId(null)
            })
            .catch(() => console.log("error"))
            .finally(() => dispatch(setPreload(false)));
    }

    return (
        <section className="system-message">
            <p className='header-system-text'>כדאי שתדעו!</p>
            <span className='system-body'>
                <div className="system-edit-text">
                    {homeObj.map(x =>
                        ShowHome && role && editId === x.Id ?
                            <MyEditor key={x.Id} homeObj={x}
                                save={save}
                                convertContentToHTML={convertContentToHTML} />
                            :
                            new Date(x.ToDate) >= new Date() || (role && ShowHome) ?
                                <Fragment key={x.Id}>
                                    <div className='system-text' dangerouslySetInnerHTML={createMarkup(x.Text)}></div>
                                    {role && ShowHome ?
                                        <Fragment>
                                            <div>{x.FromDate.split("T")[0]}</div>
                                            <div>{x.ToDate.split("T")[0]}</div>

                                            <button className='btn' onClick={() => setEditId(x.Id)}>עריכה</button>
                                            <button className='btn' onClick={() => deleteText(x.Id)}>מחיקה</button>
                                        </Fragment> : null}
                                </Fragment> : null
                    )
                    }
                    {role && ShowHome && !homeObj.findIndex(x => x.Id === -1) >= 0 ? <button className='btn' onClick={addMassage}>הוספת חדש</button> : null}
                    <div className='mehirat-hametz'>
                        <a href={`${globalFileIcon}/MehiratHametz.png`} target="_blank">
                            <i className="fas fa-file-signature signature-icon"></i>
                            לצפיה באישור מכירת חמץ תשפ״ה
                        </a>
                    </div>
                </div>
            </span>
        </section>
    )
}

export default OpenText
